"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.search.placeholder': 'Cerca pagamenti per ID sessione, descrizione, email...',
};
